// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1pczq","options":"AnswerScale_options__kRC-J","selected":"AnswerScale_selected__3nRa_"};